import { Link } from 'react-router-dom';
import BlockUi from 'react-block-ui';
import { ItemStatusBadge } from '../_components/ItemStatusBadge';
import '../../../components/jds/jds.css';
import { useItemDetailsBootstrap } from './item-details.bootstrap.hook';

export default function ItemDetails() {
  const {
    itemId,
    item,
    loading,
    formatCurrency,
    parseBoolean,
    formatBenefitsType,
  } = useItemDetailsBootstrap();

  if (loading) {
    return (
      <BlockUi tag="div" blocking={true}>
        <div style={{ height: '500px' }}></div>
      </BlockUi>
    );
  }

  if (!item) return <div className="jds-scope">Produto não encontrado.</div>;

  const rows = [
    ['Nome do produto', item.name || '-'],
    ['Código do produto', item.code || '-'],
    ['Valor', formatCurrency(item.value)],
    ['Visível para o cliente', parseBoolean(item.display_client) ? 'Sim' : 'Não'],
    [
      'Tipo de benefício',
      formatBenefitsType(item.benefitType || item.benefits_type),
    ],
  ];

  return (
    <div className="jds-scope">
      <div className="jds-card">
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ marginBottom: 'var(--space-24)' }}
        >
          <h1 className="jds-title-md">Detalhes do produto</h1>
          <Link
            to={`/payments/items/${itemId}/edit`}
            className="jds-btn jds-btn--outlined jds-btn--brand"
          >
            Editar
          </Link>
        </div>

        <div className="jds-detail-row">
          <span className="text-muted">Status</span>
          <ItemStatusBadge item={item} />
        </div>
        {rows.map(([label, value]) => (
          <div key={label} className="jds-detail-row">
            <span className="text-muted">{label}</span>
            <span style={{ fontWeight: 'var(--fw-medium)' }}>{value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
